import React from "react";
import { PortalErrorContextInterface } from "./hooks/usePortalErrorProvider";

export const PortalErrorContext =
  React.createContext<PortalErrorContextInterface>({
    handlePortalErrors: (_e: unknown) => null,
  });
